// Data (Local)
const actionGroupName = 'NOTICE'

// Constants (Local)
const NOTICE_ACTIONS = Object.freeze({
	ADD_ITEMS: `ADD_${actionGroupName}_ITEMS`,
	REMOVE_ITEMS: `REMOVE_${actionGroupName}_ITEMS`
})

// Reducer: Notice
function notice (state, action) {
	// Actions
	switch (action.type) {
		// Action: Add items
		case NOTICE_ACTIONS.ADD_ITEMS:
			return {
				...state,
				notices: [
					...(state.notices ? state.notices : []),
					...(Array.isArray(action.payload) ? action.payload : [action.payload])
				].filter((item, index, array) => {
					// Filter repeating messages
					return index === array.findIndex(notice =>
						notice.type === item.type && notice.message === item.message
					)
				})
			}
		// Action: Remove items
		case NOTICE_ACTIONS.REMOVE_ITEMS:
			return {
				...state,
				notices: state.notices
					? Array.isArray(action.id)
						? state.notices.filter(notice => !action.id.includes(notice.id))
						: state.notices.filter(notice => notice.id !== action.id)
					: state.notices
			}
		// Fallback
		default:
			return state
	}
}

// Export
export default notice
export {
	NOTICE_ACTIONS
}
